export function selectLocalizedData<T extends { localizations?: any; locale?: string | null }>(
  data: T | null | undefined,
  locale?: string
): T | any {
  if (!data) return null;
  const { localizations, ...defaultData } = data;
  if (!locale || locale === 'en') {
    return defaultData;
  }
  return data?.localizations?.find((item: any) => item.locale === locale);
}
